import React from "react";
import "./banner.css";
import Title from './../ReusableComponents/Title/Title'
import { onFormClick } from "../../utils/helper";
import useBannerData from "./useBannerData";
import analytics from "../../utils/analytics";

export default function BannerPreview({ widget, activeDashboardId }) {
  const { config = {} } = widget;
  const { bannerData, loading, reloadImage } = useBannerData(
    widget,
    activeDashboardId
  );

  const onBannerClick = () => {
    onFormClick(config);

    const analyticsData = {
      category: "widget_click",
      type: "click"
    };
    analytics.sendEvent(`banner widget clicked`, analyticsData);
  };

  return (
    <div
      className={`banner-container ${config?.navigateTo && "navigate-to"} ${
        config?.showFrame && "show-frame"
      }`}
      role="banner"
    >
      <div className="image-container" onClick={onBannerClick}>
        {loading || !bannerData?.imageURL ? (
          <span className="overflow-ellipsis">{config.name || "Banner"}</span>
        ) : (
          <img
            src={`${bannerData?.imageURL}`}
            alt="img"
            onError={reloadImage}
          />
        )}
      </div>
      {config.name && (
        <Title className={'banner-name'} text={config.name}/>
      )}
    </div>
  );
}
